import React from 'react';
import PropTypes from 'prop-types';
import LogIcon from '@material-ui/icons/ViewHeadline';
import { GraphTile } from 'grb-webui/components/GraphDashboard';
import JobLog from '../../components/JobLog';
import './JobLogDashboardTile.scss';

class JobLogDashboardTile extends React.PureComponent {
  render() {
    return (
      <GraphTile
        {...this.props}
        Icon={LogIcon}
        title="Log"
        id={this.props.id || 'jobLogTile'}
        className="grb-job-log-dashboard-tile"
      >
        <JobLog {...this.props} />
      </GraphTile>
    );
  }
}

JobLogDashboardTile.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.string,
  }),
  id: PropTypes.string,
  style: PropTypes.shape({}),
  display: PropTypes.string,
  noHeader: PropTypes.bool,
  onChangeDisplay: PropTypes.func,
  configuration: PropTypes.shape({
    noHeader: PropTypes.bool,
  }),
  elevation: PropTypes.number,
};

JobLogDashboardTile.defaultProps = {
  job: undefined,
  id: undefined,
  style: undefined,
  display: undefined,
  noHeader: undefined,
  onChangeDisplay: undefined,
  configuration: undefined,
  elevation: undefined,
};

export default JobLogDashboardTile;
